import { loan_application_api } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';
import { loan_application } from '@axo/shared/data-access/types';
import { useMutation, useQueryClient } from 'react-query';
import { applicationKeys } from '../cache-keys/applicationKeys';

interface IUseUpdateApplicationDetails {
  applicationID: string;
  patch: Partial<loan_application.LoanApplication>;
}

export function useUpdateApplicationDetails() {
  const api = useAPI();
  const client = useQueryClient();

  return useMutation(
    ({
      applicationID,
      patch,
      token,
      signal,
    }: IUseUpdateApplicationDetails & {
      token?: string;
      signal?: AbortSignal;
    }) => {
      // FIXME: Forcing token to be passed from packages/product as useAPI is not in sync and sending ''
      if (!api.token && token) api.token = token;
      return loan_application_api.patchLoanApplication(api)(
        applicationID,
        patch,
        { signal }
      );
    },
    {
      onSettled: (_, __, params) => {
        // Fire-and-forget: do not await invalidateQueries here.
        // Some queries under applicationKeys.root use never-resolving
        // promise guards (for RQ v3 premature firing), which cause
        // invalidateQueries to hang indefinitely when awaited.
        // This blocks mutateAsync callers (e.g. the accept offer flow).
        client.invalidateQueries(
          applicationKeys.root({
            applicationID: params.applicationID,
          })
        );
      },
    }
  );
}
